<template>
  <div>
    <el-container>
      <el-card>
        <el-aside
          width="200px"
          style="height: 800px; padding-right: 10px; overflow: auto"
        >
          <el-input v-model="filter" placeholder="请输入参数"></el-input>
          <el-tree
            style="margin-top: 20px"
            :data="treeData"
            :props="defaultProps"
            :expand-on-click-node="false"
            highlight-current
            :filter-node-method="nodeFilter"
            @node-click="handleNodeClick"
            ref="tree"
            node-key="id"
          ></el-tree>
        </el-aside>
      </el-card>
      <el-main class="sidebarRight">
        <el-card v-auth="'/dictionary/pageList'">
          <el-form
            ref="searchForm"
            :model="searchForm"
            :label-width="formLabelWidth"
            style="magin-top: -20px"
          >
            <el-row :gutter="20">
              <el-col :sm="24" :md="12" :lg="6">
                <el-form-item label="参数名称" prop="name">
                  <el-input
                    v-model="searchForm.name"
                    placeholder="请输入参数名称"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :md="12" :lg="6">
                <el-button
                  :size="buttonSize"
                  type="primary"
                  @click="pageList"
                  icon="el-icon-search"
                  >查询</el-button
                >
                <el-button
                  v-auth="'/dictionary/pageListreset'"
                  :size="buttonSize"
                  type="primary"
                  @click="reset"
                  icon="el-icon-refresh"
                  >重置</el-button
                >
              </el-col>
            </el-row>
          </el-form>
        </el-card>

        <el-card class="box-card" style="margin-top: 20px">
          <el-row :span="24">
            <el-col :span="12">
              <el-button
                v-auth="'/dictionary/addDictionary'"
                :size="buttonSize"
                type="primary"
                @click="addFormVisible = true"
                icon="el-icon-plus"
                >新增</el-button
              >
              <el-button
                v-auth="'/dictionary/deleteDictionary'"
                :size="buttonSize"
                type="danger"
                @click="batchDeleteDictionary"
                icon="el-icon-minus"
                >批量删除</el-button
              >
            </el-col>
            <el-col style="text-align: right" :span="12">
              <el-button
                v-auth="'/dictionary/importData'"
                :size="buttonSize"
                type="primary"
                @click="importFormVisible = true"
                icon="el-icon-download"
                >导入</el-button
              >
              <el-button
                v-auth="'/dictionary/exportExcel'"
                :size="buttonSize"
                style="text-align: right"
                type="primary"
                @click="exportExcel"
                :loading="loading"
                icon="el-icon-upload2"
                >导出</el-button
              >
            </el-col>
          </el-row>
          <el-table
            ref="multipleTable"
            :data="page.rows"
            v-loading="tableLoading"
            tooltip-effect="dark"
            style="margin-top: 20px; width: 100%"
            height="520"
            border
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="id" label="参数id"></el-table-column>
            <el-table-column prop="name" label="参数名称"></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="enabled"
              label="上架"
              align="center"
              width="80px"
            >
              <template slot-scope="row">
                <el-switch
                  v-model="row.row.enabled"
                  :active-value="1"
                  :inactive-value="0"
                  @change="enabledDictionary(row.row)"
                  class="switchStyle"
                  active-text="开"
                  inactive-text="关"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop label="操作" width="180" align="center">
              <template slot-scope="scope">
                <div class="operationGroup">
                  <span
                    v-auth="'/dictionary/updateDictionary'"
                    @click="
                      ;(selection = scope.row.id), (editFormVisible = true)
                    "
                    >编辑</span
                  >
                  <span
                    @click="deleteDictionary(scope.row)"
                    v-auth="'/dictionary/delDictionary'"
                    >删除</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="!tableLoading"
            background
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            style="margin-top: 20px; text-align: right"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </el-card>
      </el-main>
    </el-container>

    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      left
      :close-on-click-modal="false"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <!-- <el-form-item v-show="false" label="参数组id" prop="parentId">
          <el-input
            type="number"
            v-model="addForm.parentId"
            placeholder="请输入参数组id"
            auto-complete="off"
            maxlength="19"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="父参数？">
          <el-radio v-model="radio" :label="1">是</el-radio>
          <el-radio v-model="radio" :label="2">否</el-radio>
        </el-form-item>
        <el-form-item v-if="radio === 1" label="父参数" prop="parentId">
          <el-cascader
            style="width: 100%"
            clearable
            v-model="addForm.parentId"
            :show-all-levels="false"
            :props="treeDataListProps"
            placeholder="请选择父参数"
            :options="treeDataList"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="参数名称" prop="name">
          <el-input
            type="textarea"
            v-model="addForm.name"
            placeholder="请输入参数名称"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="addForm.remark"
            placeholder="请输入备注"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="addFormVisible = false"
          >取 消</el-button
        >
        <el-button :size="buttonSize" type="primary" @click="addDictionary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      left
      :close-on-click-modal="false"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <!-- <el-form-item v-show="false" label="参数组id" prop="parentId">
          <el-input
            type="number"
            v-model="editForm.parentId"
            placeholder="请输入参数组id"
            auto-complete="off"
            maxlength="19"
          ></el-input>
        </el-form-item> -->

        <el-form-item label="父参数？">
          <el-radio v-model="radio" :label="1">是</el-radio>
          <el-radio v-model="radio" :label="2">否</el-radio>
        </el-form-item>
        <el-form-item v-if="radio === 1" label="父参数" prop="parentId">
          <el-cascader
            disabled
            style="width: 100%"
            clearable
            v-model="editForm.parentId"
            :show-all-levels="false"
            :props="treeDataListProps"
            placeholder="请选择所属校区"
            :options="treeDataList"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="参数名称" prop="name">
          <el-input
            v-model="editForm.name"
            placeholder="请输入参数名称"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="editForm.remark"
            placeholder="请输入备注"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="editFormVisible = false"
          >取 消</el-button
        >
        <el-button :size="buttonSize" type="primary" @click="updateDictionary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button :size="buttonSize" type="primary" icon="el-icon-upload"
          >点击上传</el-button
        >
        <div slot="tip" class="el-upload__tip">
          只能上传xls、xlsx文件，且不超过1024kb
        </div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="参数名称"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          :size="buttonSize"
          type="primary"
          @click="importData"
          icon="el-icon-document"
          >导入数据</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tableLoading: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        parentId: "1",
        agentId: "",
        name: ""
      },
      radio: 2,
      addForm: {
        parentId: "1",
        name: "",
        remark: ""
      },
      treeDataListProps: {
        value: "id",
        children: "dictionaries",
        label: "name",
        checkStrictly: true
      },
      addFormRules: {
        parentId: [
          {
            required: true,
            message: "请输入参数组id",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入参数名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "参数名称长度在1到255个字"
          }
        ],
        remark: [
          {
            required: false,
            message: "请输入备注",
            trigger: "blur"
          },
          {
            min: 0,
            max: 255,
            message: "备注长度在0到255个字"
          }
        ]
      },
      editForm: {
        parentId: "",
        name: "",
        remark: ""
      },
      editFormRules: {
        parentId: [
          {
            required: true,
            message: "请输入参数组id",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "参数组id格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入参数名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "参数名称长度在1到255个字"
          }
        ],
        remark: [
          {
            required: false,
            message: "请输入备注",
            trigger: "blur"
          },
          {
            min: 0,
            max: 255,
            message: "备注长度在0到255个字"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/dictionary/upload`,
      fileList: [],
      loading: false,

      buttonSize: document.body.clientWidth < 992 ? "mini" : "",
      treeData: [],
      treeDataList: [],
      defaultProps: {
        children: "dictionaries",
        label: "name"
      },
      filter: ""
    };
  },
  methods: {
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getDictionary () {
      this.api.dictionary
        .getDictionaryById(this.selection)
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList () {
      this.tableLoading = true
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.dictionary
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.tableLoading = false
        })
        .catch(error => {
          this.tableLoading = false
          console.log(error);
        });
    },
    // 开关
    enabledDictionary (row) {
      this.api.dictionary.enabledDictionary({ id: row.id, enabled: row.enabled }).then(result => {
        this.pageList()
      }).catch(error => {
        this.$message.error('修改失败')
        this.pageList()
      });
    },
    addDictionary () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (typeof (this.addForm.parentId) != 'string') {
            let len = this.addForm.parentId.length
            this.addForm.parentId = this.addForm.parentId[len - 1]
          }
          this.api.dictionary
            .addDictionary(this.addForm)
            .then(result => {
              if (result.success) {
                this.addFormVisible = false;
                this.dataChange();
              } else {
                this.$message(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateDictionary () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          if (typeof (this.editForm.parentId) != 'string') {
            let len = this.editForm.parentId.length
            this.editForm.parentId = this.addForm.parentId[len - 1]
          }
          this.api.dictionary
            .updateDictionary(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.dataChange();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteDictionary (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.dictionary
            .deleteDictionary([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.dataChange()
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    batchDeleteDictionary () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.dictionary
            .deleteDictionary(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.dataChange()
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.$refs.searchForm.resetFields();
      this.searchForm.agentId = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      if (!response.success) {
        return this.$message.error(response.message);
      }
      this.importForm = response.data;
    },
    exportExcel () {
      this.loading = true;
      this.api.dictionary
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData () {
      this.api.dictionary
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getDictionaryTree () {
      this.api.dictionary
        .getDictionaryTree().then(result => {
          this.treeData = this.getTreeData(result.data);
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(result.data[0].id);
          })
          this.getDictionaryList(result.data[0].agentId)
          this.pageList()
        })
        .catch(error => {
          console.log(error);
        });
    },
    getDictionaryList (agentId) {
      this.treeDataList = [];
      this.api.dictionary.getDictionaryList({ id: 1, agentId: agentId }).then(result => {
        this.treeDataList = this.getTreeData(result.data);
      }).catch(error => {
        console.log(error);
      });
    },
    nodeFilter (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    treeFilter: function () {
      this.$refs.tree.filter(this.filter);
    },
    handleNodeClick (data) {
      this.searchForm.parentId = data.id !== data.agentId ? data.id : "1";
      this.searchForm.agentId = data.agentId;
      this.addForm.agentId = data.agentId;
      this.editForm.agentId = data.agentId;
      this.getDictionaryList(data.agentId);
      this.pageList();
    },
    getTreeData (data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].dictionaries.length === 0) {
          data[i].dictionaries = undefined;
        } else {
          this.getTreeData(data[i].dictionaries);
        }
      }
      return data;
    },
    dataChange () {
      this.searchForm.parentId = "1"
      this.searchForm.agentId = ""
      this.getDictionaryTree();
      this.pageList();
    }
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.addForm.pageList = "1";
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.editForm.pageList = "1";
      } else {
        this.getDictionary();
      }
    },
    filter: function (newVal) {
      this.treeFilter();
    }
  },
  mounted () {
    this.getDictionaryTree();
  }
};
</script>
<style scoped>
.sidebarRight {
  padding: 0px 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/index.vue